import { dataTemplate } from './dataTemplate';

const People = dataTemplate('people');

export default People;
